import React, { useContext, useState } from "react";
import { Popover, PopoverAnchor, PopoverContent } from "../../input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPencil } from "@fortawesome/free-solid-svg-icons";
import copy from "copy-to-clipboard";
import { GrigoraEditorContext } from "../context";
import { set } from "lodash";
import { toast } from "react-toastify";
import { rawCopyHandler } from "../../raw-parser";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { getTempStateLocalStorage } from "../../local-store";
import { useEditor } from "@craftjs/core";

function Debug() {
  // Debug open state
  const [debugOpen, setDebugOpen] = useState(false);

  const { editorDocument } = useContext(GrigoraDashboardContext);

  const {
    currentPage,
    pageContents,
    isNewPageContentLoading,
    projectComponents,
  } = useContext(GrigoraEditorContext);

  const { query, actions } = useEditor();

  if (!process.env.REACT_APP_GRIGORA_DEBUG_EDITOR) {
    return null;
  }

  return (
    <div>
      <Popover placement="bottom" open={debugOpen} onOpenChange={setDebugOpen}>
        <PopoverAnchor position="top">
          <div
            id="debug"
            onClick={() => setDebugOpen((v) => !v)}
            className={`grigora-editor__publish-btn w-[130px] h-10 px-3 flex justify-center items-center text-sm cursor-pointer ${
              debugOpen ? "active" : ""
            }`}
          >
            <span className="font-semibold text-grigora-base select-none">
              Dev Tools
            </span>
            <span className="ml-2">
              <FontAwesomeIcon icon={faPencil} size="sm" />
            </span>
          </div>
        </PopoverAnchor>
        <PopoverContent className="!z-[10000]">
          <div className="cursor-default text-grigora-base p-3 text-center hover:bg-ui-light-white duration-300 flex flex-col gap-2">
            <button
              onClick={(e) => {
                e.preventDefault();
                copy(pageContents[currentPage]);
                setDebugOpen(false);
                toast.success("Page JSON Copied to Clipboard");
              }}
              className="outline-none p-2 bg-slate-100 hover:bg-slate-300 duration-200"
            >
              <span className="font-semibold ">Copy Current Page JSON</span>
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                rawCopyHandler(e, actions, query, editorDocument);

                // Get temp
                copy(getTempStateLocalStorage("copiedBlocks"));

                setDebugOpen(false);
                toast.success("Copied Blocks JSON to Clipboard");
              }}
              className="outline-none p-2 bg-slate-100 hover:bg-slate-300 duration-200"
            >
              <span className="font-semibold ">Copy Selected Block JSON</span>
            </button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default Debug;
